export var SEARCH = "Search";
export var HOME = "Homepage";
export var CATEGORY = "Category";
export var PERK = "Perk";
export var PAGES = [SEARCH, HOME, CATEGORY, PERK];
export default { SEARCH: SEARCH, HOME: HOME, CATEGORY: CATEGORY, PERK: PERK, PAGES: PAGES };
